import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fold",
  "use": "fold-usage",
  "viewBox": "0 0 13.313 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.313 18\" id=\"fold\">\n  <path fill-rule=\"evenodd\" d=\"M84.252,452.885a0.825,0.825,0,0,1-.832,0L78,449.752l-5.42,3.136a0.825,0.825,0,0,1-.832,0,0.846,0.846,0,0,1-.415-0.73V436.124A1.119,1.119,0,0,1,72.444,435H83.555a1.119,1.119,0,0,1,1.111,1.125v16.031A0.846,0.846,0,0,1,84.252,452.885ZM83,436.686H73V450.7l4.587-2.654a0.826,0.826,0,0,1,.827,0L83,450.7V436.686Zm-8.333,5.063h6.667v1.687H74.667v-1.687Zm0-3.375h6.667v1.687H74.667v-1.687Z\" transform=\"translate(-71.344 -435)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/fold.svg
// module id = null
// module chunks = 